import { Button } from '@otter-ai/den-components';
import { UploadDropZone as DropZone } from '@rpldy/upload-drop-zone';
import { FILE_STATES } from '@rpldy/uploady';
import { useCallback, useMemo } from 'react';
import { useCancelAll } from '../hooks/helperHooks';
import type { UploadItem } from '../types/types';
import { UploadFileRow } from './UploadFileRow';

export function UploadDashboard({ list }: { list: UploadItem[] }) {
  const cancelAll = useCancelAll();

  // Safari fix: Set dropEffect during drag to make drop zone work in Safari
  const shouldHandleDrag = useCallback((e: DragEvent) => {
    if (e.dataTransfer) {
      e.dataTransfer.dropEffect = 'copy';
    }
    return true;
  }, []);

  const canCancelAll = useMemo(() => {
    return list.some(
      (item) =>
        item.state === FILE_STATES.UPLOADING ||
        item.state === FILE_STATES.PENDING ||
        item.state === FILE_STATES.ADDED,
    );
  }, [list]);

  if (list.length === 0) {
    return null;
  }

  return (
    <DropZone
      className="flex-1 overflow-y-auto"
      shouldHandleDrag={shouldHandleDrag}
    >
      <div className=" flex-1 w-full scroll-bar-hide">
        {canCancelAll && (
          <div className="flex justify-end h-11 bg-palette-gray-100">
            <Button
              size="md"
              className="min-w-fit max-w-[120px] px-2"
              variant="ghost"
              onClick={() => cancelAll(list)}
            >
              <span className="text-primary">Cancel all</span>
            </Button>
          </div>
        )}
        <div className="flex flex-col">
          {list.map((item) => (
            <UploadFileRow item={item} key={item.id} />
          ))}
        </div>
      </div>
    </DropZone>
  );
}
